import { cookieConsentHandler, listenToNativeApp } from '@/helpers/nativeAppBridge'
import { isNativeApp } from '@red-ui/bridge'
import { useEffect } from 'react'

export const useHybridAppSetup = () => {
  useEffect(() => {
    if (!isNativeApp()) return

    const cleanup = listenToNativeApp({
      cookie_consent: cookieConsentHandler(),
    })
    return cleanup
  }, [])
}
